export const getBreakReductionMinutes = (duration, weekendOrHoliday) => {
  if (duration === 30) return weekendOrHoliday ? 120 : 60;
  if (duration === 60) return weekendOrHoliday ? 240 : 120;
  return 0;
};
